import _jsx from '@babel/runtime/helpers/jsx';
import React from 'react';
import classnames from 'classnames';
import Button from '@andes/button';
const namespace$1 = 'ui-vpp-tag-limited';

/**
 * PlusButton component
 * @typedef {import('../index').PlusButton}
 */
const PlusButton = _ref => {
  let {
    onClick = null,
    extraItems = 0
  } = _ref;
  return /*#__PURE__*/_jsx("li", {
    className: `${namespace$1}__list-item`
  }, void 0, /*#__PURE__*/_jsx(Button, {
    hierarchy: "quiet",
    size: "medium",
    className: `${namespace$1}__plus-button`,
    onClick: onClick
  }, void 0, `+${extraItems}`, ' '));
};

/**
 * TagLimited component
 * @typedef {import('../index').TagLimited}
 */
const TagLimited = _ref2 => {
  let {
    className = '',
    limit,
    children = null,
    onClickPlusButton = null,
    aria_label = '',
    id = ''
  } = _ref2;
  const tagChildren = React.Children.toArray(children);
  const extraItems = tagChildren.length - limit;
  const getVisibleTags = tags => tags.slice(0, limit);
  const getKeyByIndex = index => `${id || namespace$1}-item-${index}`;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(namespace$1, className),
    "aria-label": aria_label
  }, void 0, /*#__PURE__*/_jsx("ul", {
    className: `${namespace$1}_container`
  }, id, getVisibleTags(tagChildren).map((tag, index) => /*#__PURE__*/_jsx("li", {
    className: `${namespace$1}__list-item`
  }, getKeyByIndex(index), tag)), tagChildren.length > limit && /*#__PURE__*/_jsx(PlusButton, {
    onClick: onClickPlusButton,
    extraItems: extraItems
  })));
};
const namespace = 'ui-vpp-tag-limited';

/**
 * TagElement component
 * @typedef {import('../index').TagElement}
 */
const TagElement = _ref => {
  let {
    children = null,
    aria_label = '',
    id = ''
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "aria-label": aria_label,
    className: `${namespace}_element`
  }, id, children);
};
export { TagElement, TagLimited };
